import axios from "axios";

// 获取歌词
export const getWords = id => {
  // 原路径：https://netease-cloud-music-api.fe-mm.com/lyric?id=${id}
  return axios.get(`/netease/lyric?id=${id}`); // 改为代理路径
};

// 获取歌曲详情
export const getMusicInfo = id => {
  // 原路径：https://netease-cloud-music-api.fe-mm.com/song/detail?ids=${id}
  return axios.get(`/netease/song/detail?ids=${id}`); // 改为代理路径
};

// 获取歌曲url
export const getMusicUrl = id => {
  // 原路径：https://netease-cloud-music-api.fe-mm.com/song/url?id=${id}
  return axios.get(`/netease/song/url?id=${id}`); // 改为代理路径
};

// 获取热门歌曲
export const getHotMusic = id => {
  // 原路径：https://netease-cloud-music-api.fe-mm.com/playlist/detail?id=${id}
  return axios.get(`/netease/playlist/detail?id=${id}`); // 改为代理路径
};

// 获取搜索建议
export const getSearchSuggest = key => {
  // 原路径：https://netease-cloud-music-api.fe-mm.com/search/suggest?keywords=${key}
  return axios.get(`/netease/search/suggest?keywords=${key}`); // 改为代理路径
};

// 获取歌曲热门评论
export const getHotTalk = id => {
  // 原路径：https://netease-cloud-music-api.fe-mm.com/comment/music?id=${id}&limit=3
  return axios.get(`/netease/comment/music?id=${id}&limit=3`); // 改为代理路径
};